// @flow
// libs
import React from 'react';
import IMAGES from '../../constans/images';

type Props = {
  onClick: Function,
  isDisabled?: any,
  customClass?: string,
  children: any,
  type?: string,
};

const Button = ({
  isDisabled = false,
  onClick,
  customClass = '',
  children,
  type,
}: Props) => {
  return (
    <button
      type={type}
      className={`${customClass}`}
      disabled={isDisabled}
      onClick={onClick}
    >
      {children}
      {
        customClass == 'btn-continue' && <img src={IMAGES.iconNextButton} alt="" className='img-next'/>
      }
      
    </button>
  );
};

Button.defaultProps = {
  isDisabled: false,
  customClass: '',
  type: 'submit',
};

export default Button;
